/**
 * The home page's own query string: the members card's filter and page
 * (`docs/design/permissions/PERMISSIONS_UI_DESIGN.md`, "Routes and gates": filters and their page
 * stay in the query string, so Back undoes them and a link can be shared).
 */

export const MEMBERS_FILTER_PARAMETER = "members";
export const MEMBERS_PAGE_PARAMETER = "membersPage";

export type MembersSearch = Readonly<{ search: string; pageIndex: number }>;

/** The members filter and page the query string holds. The page is one-based in the address. */
export function readMembersSearch(params: URLSearchParams): MembersSearch {
  const page = Number.parseInt(params.get(MEMBERS_PAGE_PARAMETER) ?? "1", 10);
  return {
    search: (params.get(MEMBERS_FILTER_PARAMETER) ?? "").trim(),
    pageIndex: Number.isFinite(page) && page > 1 ? page - 1 : 0,
  };
}

/** The query string with these members filter and page, leaving out what is the default. */
export function withMembersSearch(params: URLSearchParams, members: MembersSearch): URLSearchParams {
  const next = new URLSearchParams(params);
  next.delete(MEMBERS_FILTER_PARAMETER);
  next.delete(MEMBERS_PAGE_PARAMETER);
  if (members.search) next.set(MEMBERS_FILTER_PARAMETER, members.search);
  if (members.pageIndex > 0) next.set(MEMBERS_PAGE_PARAMETER, String(members.pageIndex + 1));
  return next;
}
